document.addEventListener('DOMContentLoaded', () => {

    const toolExists = document.querySelector('.calculator-dimensions-tool');
    if (!toolExists) {
        return;
    }

    const inputs = {
        kokgryta_utlopp_25: { qi: 1.00, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        kokgryta_utlopp_50: { qi: 2.00, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        tippbar_kokgryta_utlopp_70: { qi: 1.00, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        tippbar_kokgryta_utlopp_100: { qi: 3.00, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        diskho_vattenlas_40: { qi: 0.80, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        diskho_vattenlas_50: { qi: 1.50, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        diskho_utan_vattenlas_40: { qi: 2.50, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        diskho_utan_vattenlas_50: { qi: 4.00, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        diskmaskin: { qi: 2.00, factors: [0.6, 0.45, 0.40, 0.34, 0.30] },
        tippbart_stekbord: { qi: 1.00, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        fast_stekbord: { qi: 0.10, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        hogtryckstvatt_angtvatt: { qi: 2.00, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        skrapa: { qi: 1.50, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        gronsakstvatt: { qi: 2.00, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        tappventil_dn15: { qi: 0.50, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        tappventil_dn20: { qi: 1.00, factors: [0.45, 0.31, 0.25, 0.21, 0.20] },
        tappventil_dn25: { qi: 1.70, factors: [0.45, 0.31, 0.25, 0.21, 0.20] }
    };

    const summaryFlowEl = document.querySelectorAll('.summary_row .value')[0];
    const summaryNominalSizeEl = document.querySelectorAll('.summary_row .value')[1];
    function calculateQs() {
        let totalQs = 0;
        const diskmedel = parseFloat(document.querySelector('input[name="diskmedelsfaktor"]:checked')?.value || 1);
        const densitet = parseFloat(document.querySelector('input[name="densitetsfaktor"]:checked')?.value || 1);
        const temperatur = parseFloat(document.querySelector('input[name="temperatursfaktor"]:checked')?.value || 1);

        const selectedItems = [];

        Object.keys(inputs).forEach(id => {
            const inputEl = document.getElementById(id);
            const amount = parseInt(inputEl?.value) || 0;
            if (amount > 0) {
                const factorIndex = Math.min(amount - 1, inputs[id].factors.length - 1);
                const factor = inputs[id].factors[factorIndex] || 1;

                const Qs_per_unit = inputs[id].qi * factor * diskmedel * densitet * temperatur;

                const Qs_total = Qs_per_unit * amount;

                totalQs += Qs_total;

                selectedItems.push({
                    name: inputEl.getAttribute('data-name') || id,
                    quantity: amount,
                    qs_per_unit: Qs_per_unit.toFixed(2),
                    qs_total: Qs_total.toFixed(2)
                });
            }
        });


        document.getElementById('selected_items').value = JSON.stringify(selectedItems);

        return totalQs;
    }

    function getNominalSize(Qs) {
        if (Qs === 0) return '';
        if (Qs <= 0.25) return 'NS 0,25';
        if (Qs <= 0.5) return 'NS 0,50';
        if (Qs <= 1) return 'NS 1';
        if (Qs <= 2) return 'NS 2';
        if (Qs <= 3) return 'NS 3';
        if (Qs <= 4) return 'NS 4';
        if (Qs <= 7) return 'NS 7';
        if (Qs <= 10) return 'NS 10';
        if (Qs <= 15) return 'NS 15';
        if (Qs <= 20) return 'NS 20';
        if (Qs <= 25) return 'NS 25';
        if (Qs <= 30) return 'NS 30';
        if (Qs <= 35) return 'NS 35';
        return 'Kontakta GPA';
    }

    function updateSummary() {
        const Qs = calculateQs();
        const NSLabel = getNominalSize(Qs);
        summaryFlowEl.textContent = Qs.toFixed(2) + ' l/s';
        summaryNominalSizeEl.textContent = NSLabel;
    }

    Object.keys(inputs).forEach(id => {
        document.getElementById(id).addEventListener('input', updateSummary);
    });

    document.querySelectorAll('.input-section input[type="radio"]').forEach(input => {
        input.addEventListener('change', updateSummary);
    });

    document.querySelector('.reset').addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelectorAll('.calculate-form input[type="number"]').forEach(input => {
            input.value = "";
        });

        document.querySelectorAll('.calculate-form input[type="radio"]').forEach(radio => {
            if (radio.hasAttribute('checked')) {
                radio.checked = true;
            } else {
                radio.checked = false;
            }
        });

        document.getElementById("pdf-flow").value = "";
        document.getElementById("pdf-nominal-size").value = "";
        document.getElementById("selected_items").value = "";
        document.getElementById("selected_safety_factors").value = "";

        updateSummary();


    });

    updateSummary();

    const pdfForm = document.querySelector("form input[name='action'][value='generate_pdf']")?.closest("form");

    if (!pdfForm) {
        console.log("Hittade inget formulär!");
        return;
    }

    pdfForm.addEventListener("submit", (event) => {
        event.preventDefault();

        let selectedItems = [];
        let selectedSafetyFactors = [];

        const totalQs = calculateQs();
        const summaryNominalSizeEl = document.querySelector(".nominal-size-value")?.textContent.trim() || "Ej angivet";
        document.getElementById('pdf-flow').value = totalQs.toFixed(2) + " l/s";
        document.getElementById('pdf-nominal-size').value = summaryNominalSizeEl;
        const pdfDiskmedelsfaktor = document.getElementById('pdf-diskmedelsfaktor');
        if (pdfDiskmedelsfaktor) {
            pdfDiskmedelsfaktor.value = document.querySelector('input[name="diskmedelsfaktor"]:checked')?.value || "";
        }

        const pdfDensitetsfaktor = document.getElementById('pdf-densitetsfaktor');
        if (pdfDensitetsfaktor) {
            pdfDensitetsfaktor.value = document.querySelector('input[name="densitetsfaktor"]:checked')?.value || "";
        }

        const pdfTemperatursfaktor = document.getElementById('pdf-temperatursfaktor');
        if (pdfTemperatursfaktor) {
            pdfTemperatursfaktor.value = document.querySelector('input[name="temperatursfaktor"]:checked')?.value || "";
        }

        const pdfFlow = document.getElementById('pdf-flow');
        if (pdfFlow) {
            pdfFlow.value = totalQs.toFixed(2) + " l/s";
        }

        const pdfNominalSize = document.getElementById('pdf-nominal-size');
        if (pdfNominalSize) {
            pdfNominalSize.value = summaryNominalSizeEl;
        }

        Object.keys(inputs).forEach(id => {
            const inputEl = document.getElementById(id);
            const amount = parseInt(inputEl?.value) || 0;
            if (amount > 0) {
                const factorIndex = Math.min(amount - 1, inputs[id].factors.length - 1);
                const factor = inputs[id].factors[factorIndex] || 1;

                const Qs_per_unit = inputs[id].qi * factor;
                const Qs_total = Qs_per_unit * amount;

                selectedItems.push({
                    name: inputEl.getAttribute("data-name") || id,
                    quantity: amount,
                    qs_per_unit: Qs_per_unit.toFixed(2),
                    qs_total: Qs_total.toFixed(2)
                });
            }
        });

        document.querySelectorAll(".radio-input-section input[type='radio']:checked").forEach(input => {
            let group = input.closest(".input-group");
            let label = group.querySelector("p")?.textContent.trim() || "N/A";
            let selectedOptionText = input.nextSibling?.textContent.trim() || input.value;

            selectedSafetyFactors.push({
                name: label,
                value: input.value,
                label: selectedOptionText
            });
        });

        document.getElementById("selected_items").value = JSON.stringify(selectedItems);
        document.getElementById("selected_safety_factors").value = JSON.stringify(selectedSafetyFactors);

        setTimeout(() => pdfForm.submit(), 100);
    });
});

document.addEventListener("DOMContentLoaded", function () {

    const toolExists = document.querySelector('.calculator-dimensions-tool');
    if (!toolExists) {
        return;
    }

    document.querySelectorAll(".toggle-section").forEach(button => {
        console.log("🔹 Found toggle button:", button);
        button.addEventListener("click", function () {
            const targetSelector = this.getAttribute("data-target").trim();
            const target = document.querySelector(targetSelector);

            console.log("🔹 Toggle target:", target);
            console.log("🔹 Toggle target classList:", target?.classList);

            if (target) {
                target.classList.toggle("collapsed");
                this.classList.toggle("collapsed");
                const sectionTitle = this.closest(".section-title");

                const isDelaySection = sectionTitle.classList.contains("delay-section");

                if (sectionTitle) {
                    if (target.classList.contains("collapsed")) {
                        if (isDelaySection) {
                            setTimeout(() => {
                                sectionTitle.classList.add("no-margin");
                            }, 300);
                        } else {
                            sectionTitle.classList.add("no-margin");
                        }
                    } else {
                        sectionTitle.classList.remove("no-margin");
                    }
                }
                const isCollapsed = target.classList.contains("collapsed");
                this.innerHTML = isCollapsed
                    ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="#007B92" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H12.75V20.25C12.75 20.4489 12.671 20.6397 12.5303 20.7803C12.3897 20.921 12.1989 21 12 21C11.8011 21 11.6103 20.921 11.4697 20.7803C11.329 20.6397 11.25 20.4489 11.25 20.25V12.75H3.75C3.55109 12.75 3.36032 12.671 3.21967 12.5303C3.07902 12.3897 3 12.1989 3 12C3 11.8011 3.07902 11.6103 3.21967 11.4697C3.36032 11.329 3.55109 11.25 3.75 11.25H11.25V3.75C11.25 3.55109 11.329 3.36032 11.4697 3.21967C11.6103 3.07902 11.8011 3 12 3C12.1989 3 12.3897 3.07902 12.5303 3.21967C12.671 3.36032 12.75 3.55109 12.75 3.75V11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12Z" fill="#007B92"/>
                            </svg>`
                    : `<svg width="24" height="24" viewBox="0 0 24 24" fill="#007B92" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.25 12.75H3.75C3.55109 12.75 3.36032 12.671 3.21967 12.5303C3.07902 12.3897 3 12.1989 3 12C3 11.8011 3.07902 11.6103 3.21967 11.4697C3.36032 11.329 3.55109 11.25 3.75 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75Z"/>
                            </svg>`;
            } else {
                console.warn(" Ingen matchande sektion hittades för: ", targetSelector);
            }
        });
    });
});



document.addEventListener("DOMContentLoaded", function () {

    const toolExists = document.querySelector('.calculator-dimensions-tool');
    if (!toolExists) {
        return;
    }

    const pdfPopup = document.getElementById("pdfPopup");
    const pdfButton = document.getElementById("openPdfPopup"); // Använd rätt ID
    const closeButtons = document.querySelectorAll(".close-popup");
    const downloadButton = document.querySelector(".download_pdf");

    if (!pdfPopup) {
        console.error("❌ Popup-elementet hittades inte!");
        return;
    }

    if (!pdfButton) {
        console.error("❌ PDF-knappen hittades inte!");
        return;
    }


    const spinner = document.getElementById("dimension-spinner-download");
    const pdfForm = document.getElementById("pdfForm");

    downloadButton.addEventListener("click", function () {
        pdfPopup.classList.add("loading");
        spinner.style.display = "flex";

        setTimeout(() => {
            pdfPopup.style.display = "none";
            pdfPopup.classList.remove("loading");
            spinner.style.display = "none";

            pdfForm.reset();
        }, 2000); // 2 sekunder
    });


    // Logga för felsökning
    console.log("✅ PDF-knappen hittades:", pdfButton);
    console.log("✅ Popup-element hittades:", pdfPopup);

    pdfButton.addEventListener("click", function (event) {
        event.preventDefault();
        console.log("📌 Klick på Ladda ner PDF-knappen!");

        // Se till att popup visas
        pdfPopup.style.display = "flex";
    });

    closeButtons.forEach(button => {
        button.addEventListener("click", function () {
            pdfPopup.style.display = "none";
        });
    });

    // Stäng popup om man klickar utanför innehållet
    pdfPopup.addEventListener("click", function (event) {
        if (event.target === pdfPopup) {
            pdfPopup.style.display = "none";
        }
    });
});